import React from 'react';
import { Stack, Form } from 'react-bootstrap';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import UploadFile from '../../../../../components/UploadFile';
import { Attachments } from './components/Attachments';

export type StepReasonFilesProps = {
  reason: string;
  setReason: (reason: string) => void;
  selectedFiles: File[];
  setSelectedFiles: (files: File[]) => void;
  isReasonMandatory: boolean;
  hideReason: boolean;
  hideAttachment: boolean;
  isUploadMandatory: boolean;
};

export const StepReasonFiles: React.FC<
  React.PropsWithChildren<StepReasonFilesProps>
> = ({
  reason,
  setReason,
  selectedFiles,
  setSelectedFiles,
  isReasonMandatory,
  hideReason,
  hideAttachment,
  isUploadMandatory,
}) => {
  const t = useNamespacedTranslation('changeRequests.requestForm');

  return (
    <Stack gap={3}>
      {!hideReason && (
        <div>
          <Form.Group>
            <Form.Label>
              {t('reason.label')}
              {isReasonMandatory && <span className="text-danger"> *</span>}
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder={t('reason.placeholder')}
              required={isReasonMandatory}
            />
          </Form.Group>
        </div>
      )}

      {!hideAttachment && (
        <div>
          <Form.Label>
            {t('attachments.label')}
            {isUploadMandatory && <span className="text-danger"> *</span>}
          </Form.Label>
          <UploadFile
            multiple
            acceptExtensions=".jpg,.jpeg,.png,.pdf,.txt"
            onChange={(files: FileList) =>
              setSelectedFiles([...selectedFiles, ...Array.from(files)])
            }
          />
          <Attachments
            files={selectedFiles}
            onChange={(files: File[]) => setSelectedFiles(files)}
          />
        </div>
      )}
    </Stack>
  );
};
